export default "__VITE_ASSET__jev4m5o3__"